import { connect } from 'react-redux';

import * as stepTwoModule from '../../modules/stepTwo';
import * as stepThreeModule from '../../modules/stepThree';
import StepTwo from '../../components/StepTwo/StepTwo';


const mapStateToProps = state => {
  const {
    postalInfo,
  } = state.stepOne;

  const {
    currentService,
  } = state.stepTwo;

  return {
    postalInfo,
    currentService,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchSetCurrentService: selected => {
      dispatch(stepTwoModule.setCurrentService(selected));
      dispatch(stepThreeModule.selectTab(1 - selected));
    },
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(StepTwo);
